export default {
  "account": {
    "curatedCollections": "Επιλεγμένες Συλλογές",
    "curatedCollectionsInfo": "Βρείτε παραπάνω όλες τις συλλογές που έχετε επιλέξει",
    "editProfile": "Επεξεργασία προφίλ",
    "likes": "Like",
    "linkAccount": "Ο λογαριασμός μου",
    "linkLogin": "Σύνδεση",
    "linkLoginJoin": "Εγγραφή/Σύνδεση",
    "linkLogout": "Αποσύνδεση",
    "myProfile": "ΤΟ ΠΡΟΦΙΛ ΜΟΥ",
    "notifications": {
      "loggedIn": "Έχετε συνδεθεί τώρα. Καλώς ήλθατε!",
      "loggedOut": "Έχετε αποσυνδεθεί τώρα.",
      "noCollections": {
        "curated": "Δεν έχετε επιλέξει ακόμη καμία συλλογή",
        "private": "Δεν έχετε δημιουργήσει ιδιωτικές συλλογές",
        "public": "Δεν έχετε δημιουργήσει δημόσιες συλλογές"
      },
      "noLikedItems": "Δεν έχετε πατήσει like σε κάποιο αντικείμενο"
    },
    "privateCollections": "Ιδιωτικές συλλογές",
    "profile": "Τα like και οι συλλογές μου",
    "profileSettings": "Ρυθμίσεις προφίλ",
    "publicCollections": "Δημόσιες συλλογές",
    "settings": "Ρυθμίσεις",
    "title": "Ο λογαριασμός μου"
  },
  "actions": {
    "accept": "Αποδέχομαι",
    "cancel": "Ακύρωση",
    "close": "κλείσιμο",
    "continue": "Συνέχεια",
    "download": "Μεταφόρτωση",
    "edit": "Επεξεργασία",
    "feedback": "Σχόλια",
    "goBack": "Πίσω",
    "goHome": "Μεταβείτε στην αρχική σελίδα",
    "learnMore": "Μάθε περισσότερα",
    "like": "Like",
    "move": "Μετακινήστε",
    "next": "Επόμενο",
    "pin": "Καρφίτσα",
    "preview": "Προεπισκόπηση",
    "previous": "Προηγούμενος",
    "providedBy": "Παρέχεται από {provider}",
    "reject": "Απορρίπτω",
    "save": "Αποθήκευση",
    "send": "Στείλετε",
    "share": "Κοινοποίηση",
    "shareOn": "Κοινοποίηση στο {social}",
    "skip": "Παραλείπω",
    "viewAt": "Προβολή στο {link}",
    "viewDocument": "Προβολή εγγράφου"
  },
  "attribution": {
    "country": "Χώρα:",
    "creator": "Δημιουργός:",
    "date": "Ημερομηνία:",
    "institution": "Ίδρυμα:",
    "title": "Τίτλος:"
  },
  "automatedCardGroup": {
    "item": "Πρόσφατα αντικείμενα",
    "organisation": "Οργανώσεις",
    "place": "Μέρη",
    "time": "Προτεινόμενοι αιώνες",
    "topic": "Προτεινόμενα θέματα"
  },
  "blog": {
    "author": "Συγγραφέας",
    "authors": "Συγγραφείς",
    "blog": "Blog",
    "by": "από τον/την",
    "categories": "Κατηγορίες",
    "category": "Κατηγορία",
    "posts": "Ανάρτηση στο blog | Αναρτήσεις στο blog ",
    "published": "Δημοσιεύτηκε στις {date}",
    "relatedPosts": "Σχετικές αναρτήσεις"
  },
  "cardLabels": {
    "organisation": "Οργάνωση",
    "person": "Πρόσωπο",
    "place": "Θέση",
    "theme": "Θέμα",
    "time": "Αιώνας",
    "topic": "Θέμα"
  },
  "clearAllFilters": "απαλοιφή όλων των φίλτρων",
  "collections": {
    "actions": {
      "edit": "Επεξεργασία συλλογής",
      "update": "Ενημέρωση συλλογής"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "σχεδιαστές",
          "name": "Σχεδιαστής | Σχεδιαστές",
          "select": "Επιλέξτε σχεδιαστές"
        },
        "proxy_dc_format": {
          "moreName": "τεχνικές",
          "name": "Τεχνική | Τεχνικές",
          "select": "Επιλέξτε τεχνικές"
        },
        "proxy_dc_type": {
          "moreName": "τύπους αντικειμένων",
          "name": "Τύπος αντικειμένου | Τύποι αντικειμένων",
          "select": "Επιλέξτε τύπους αντικειμένων"
        },
        "proxy_dcterms_medium": {
          "moreName": "υλικά",
          "name": "Υλικό | Υλικά",
          "select": "Επιλέξτε υλικά"
        }
      }
    },
    "form": {
      "description": "Περιγραφή"
    },
    "notifications": {
      "update": "Η συλλογή έχει ενημερωθεί"
    }
  },
  "collectionsYouMightLike": "Συλλογές που μπορεί να σας αρέσουν",
  "colourSwatch": "Δείγμα χρώματος",
  "contentYouMightLike": "Περιεχόμενο που μπορεί να σας αρέσει",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Περισσότερες πληροφορίες",
      "about": "Σχετικά με τις συλλογές της Europeana",
      "forDevelopers": "Για προγραμματιστές",
      "help": "Βοήθεια",
      "meetUs": "Γνωρίστε την ομάδα",
      "provide": "Γίνετε πάροχος δεδομένων",
      "subscribe": "Εγγραφή στο newsletter",
      "terms": "Όροι χρήσης και πολιτική απορρήτου"
    },
    "headerNavigation": {
      "Collections": "Συλλογές",
      "explore": "Εξερεύνηση",
      "teachers": "Εκπαιδευτικοί"
    }
  },
  "curatedAutomatically": "Αυτόματη επιμέλεια από την Europeana",
  "dateFilter": {
    "endDate": "Ημερομηνία λήξης",
    "specificDate": "Συγκεκριμένη ημερομηνία",
    "startDate": "Ημερομηνία έναρξης",
    "to": "έως"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Κλειδί Europeana API",
      "noRequests": "Δεν χρησιμοποιήθηκαν αιτήματα προς Europeana API σε αυτήν τη σελίδα.",
      "settingsPageLinkText": "σελίδα ρυθμίσεων",
      "tip": "Συμβουλή: εάν έχετε ήδη ένα {apiKeyLink} , μπορείτε να το εισαγάγετε στο {settingsPageLink} και θα συμπεριληφθεί σε αυτούς τους συνδέσμους αιτημάτων API.",
      "title": "Αιτήματα API"
    },
    "debug": "Εντοπισμός σφαλμάτων",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Εισαγάγετε το κλειδί Europeana API και θα χρησιμοποιηθεί στους συνδέσμους προς τα αιτήματα API.",
          "label": "Κλειδί API"
        },
        "boosting": {
          "description": "Εάν είναι ενεργοποιημένο, ενεργοποιεί το πεδίο ενίσχυσης στις σελίδες αποτελεσμάτων αναζήτησης, για να αξιολογήσει διάφορες διαμορφώσεις ενίσχυσης.",
          "label": "Ενεργοποίηση ενίσχυσης πεδίου"
        },
        "enabled": {
          "description": "Εάν είναι ενεργοποιημένο, το μενού εντοπισμού σφαλμάτων θα εμφανίζεται στο υποσέλιδο της σελίδας.",
          "label": "Ενεργοποίηση μενού εντοπισμού σφαλμάτων"
        }
      },
      "title": "Ρυθμίσεις"
    }
  },
  "delete": "Διαγραφή",
  "depiction": "Μια απόδοση του {title}",
  "directions": {
    "left": "Αριστερά",
    "right": "Δεξιά"
  },
  "edmIsShownAtLinkAlt": "Προβολή στον ιστότοπο του παρόχου",
  "entity": {
    "actions": {
      "cancel": "Ακύρωση",
      "pin": "Καρφίτσωμα αντικειμένου",
      "unpin": "Ξεκαρφίτσωμα αντικειμένου",
      "viewPinned": "Δείτε τα καρφιτσωμένα αντικείμενα"
    },
    "labels": {
      "entity": "Οντότητα"
    },
    "notifications": {
      "deleted": "Η συλλογή σας διαγράφηκε.",
      "error": {
        "unpin": "Παρουσιάστηκε σφάλμα κατά το ξεκαρφίτσωμα του αντικειμένου. Δοκιμάστε ξανά ή αναφέρετε το πρόβλημα."
      },
      "pin": "Αυτό το αντικείμενο θα εμφανίζεται στην κορυφή της συλλογής \"{entity}\". Θα σας ειδοποιήσουμε όταν αυτή η αλλαγή θα είναι ορατή στην συλλογή.",
      "pinLimit": {
        "body": "Προς το παρόν, μπορείτε να καρφιτσώσετε μόνο 24 στοιχεία στην πρώτη σελίδα. Εάν θέλετε να καρφιτσώσετε αυτό το στοιχείο, βεβαιωθείτε ότι έχετε ξεκαρφιτσώσει ένα άλλο και στη συνέχεια προσπαθήστε να το καρφιτσώσετε ξανά.",
        "title": "Πάρα πολλά καρφιτσωμένα στοιχεία"
      },
      "pinned": "Το στοιχείο έχει καρφιτσωθεί. Βρίσκεται τώρα στην κορυφή της πρώτης σελίδας αυτής της συλλογής. Μπορεί να χρειαστούν έως και 24 ώρες για να εμφανιστεί σε όλους.",
      "select": "Επιλέξτε μια σχετική οντότητα για να καρφιτσώσετε/ξεκαρφιτσώσετε το αντικείμενο σε/από αυτό.",
      "unpin": "Αυτό το αντικείμενο θα σταματήσει να εμφανίζεται στην κορυφή της συλλογής \" {entity} \". Θα σας ειδοποιήσουμε όταν αυτή η αλλαγή θα είναι ορατή στην συλλογή.",
      "unpinned": "Το αντικείμενο ξεκαρφιτσώθηκε. Δεν βρίσκεται πλέον στην κορυφή της πρώτης σελίδας αυτής της συλλογής. Μπορεί να χρειαστούν έως και 24 ώρες για να εξαφανιστούν για όλους."
    }
  },
  "error": "Σφάλμα",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Αυτό δεν είναι δυνατό, επειδή οι ιδιωτικές συλλογές είναι ορατές μόνο στον δημιουργό τους. Εάν γνωρίζετε τον δημιουργό της συλλογής, ζητήστε του να δημοσιοποιήσει την συλλογή. Εναλλακτικά, αναφέρετε αυτό το πρόβλημα χρησιμοποιώντας το κουμπί σχολίων.",
      "metaTitle": "Συλλογή μη εξουσιοδοτημένη",
      "title": "Ωχ! {newline} Προσπαθείτε να δείτε την ιδιωτική συλλογή άλλου ατόμου."
    },
    "itemNotFound": {
      "description": "Αυτό μπορεί να οφείλεται στους ακόλουθους λόγους: αυτό το στοιχείο δεν υπάρχει ή καταργήθηκε επειδή δεν πληρούσε τα ποιοτικά μας κριτήρια, ή ενημερώθηκε και αναδημοσιεύτηκε με ένα νέο μοναδικό αναγνωριστικό, οπότε προσπαθήστε να βρείτε ξανά το στοιχείο.",
      "metaTitle": "Το στοιχείο δε βρέθηκε",
      "title": "Ωχ όχι! {newline} Δεν μπορέσαμε να βρούμε αυτό το στοιχείο."
    }
  },
  "exhibitions": {
    "chapters": "Κεφάλαια",
    "credits": "Συντελεστές",
    "currentChapter": "Τρέχον κεφάλαιο",
    "description": "Εξερευνήστε τις εκθέσεις",
    "exhibitions": "Έκθεση | Εκθέσεις"
  },
  "explore": "Εξερευνήστε",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "Χρώματα",
      "name": "Χρώμα | Χρώματα",
      "options": {
        "#000000": "Μαύρο",
        "#000080": "Ναυτικό μπλε",
        "#00008B": "Σκούρο μπλε",
        "#0000CD": "Μεσαίο μπλε",
        "#0000FF": "Μπλε",
        "#006400": "Σκούρο πράσινο",
        "#008000": "Πράσινο",
        "#008080": "Βάσκας",
        "#008B8B": "Σκούρο κυανό",
        "#00BFFF": "Βαθύ μπλε του ουρανού",
        "#00CED1": "Σκούρο Τυρκουάζ",
        "#00FA9A": "Φωτεινό πράσινο",
        "#00FF00": "Πράσινο",
        "#00FF7F": "Ανοιξιάτικο πράσινο",
        "#00FFFF": "Κυανό",
        "#191970": "Πολύ σκούρο μπλε",
        "#1E90FF": "Σκούρο Σιέλ",
        "#20B2AA": "Ανοιχτό πράσινο της θάλασσας",
        "#228B22": "Σκούρο λάιμ",
        "#2E8B57": "Πράσινο κυπαρισσί",
        "#2F4F4F": "Σκούρο πρασινογκρι",
        "#32CD32": "Λάιμ",
        "#3CB371": "Μεσαίο πράσινο",
        "#40E0D0": "Τυρκουάζ",
        "#4169E1": "Μπλε ρουά",
        "#4682B4": "Ανοιχτό μπλε",
        "#483D8B": "Σκούρο μπλε πλάκα",
        "#48D1CC": "Μεσαίο Τυρκουάζ",
        "#4B0082": "Μπλέ ιώδες",
        "#556B2F": "Σκούρο πράσινο ελίας",
        "#5F9EA0": "Πετρόλ",
        "#6495ED": "Απαλό μπλε",
        "#663399": "Σκούρο βιολετί",
        "#66CDAA": "Mεσαίο γαλαζοπράσινο",
        "#696969": "Σκούρο γκρι",
        "#6A5ACD": "Μεσαίο μπλε βιολετί",
        "#6B8E23": "Πράσινο της ελιάς",
        "#708090": "Γκρίζο μπλε",
        "#778899": "Ανοιχτό γκρίζο μπλε",
        "#7B68EE": "Μεσαίο μπλε",
        "#7CFC00": "Έντονο πράσινο",
        "#7F0000": "Σκούρο κόκκινο",
        "#7F007F": "Μωβ",
        "#7FFF00": "Κιτρινοπράσινο",
        "#7FFFD4": "Άκουαμαρινα",
        "#800000": "Μαρόν",
        "#800080": "Μωβ",
        "#808000": "Ελιά",
        "#808080": "Γκρί",
        "#87CEEB": "Γαλάζιο του ουρανού",
        "#87CEFA": "Ελαφρύ γαλάζιου του ουρανού",
        "#8A2BE2": "Μπλε βιολετί",
        "#8B0000": "Μεσαίο κόκκινο",
        "#8B008B": "Σκούρο Ματζέντα",
        "#8B4513": "Σκούρο καφέ",
        "#8FBC8F": "Πράσινη σκοτεινή θάλασσα",
        "#90EE90": "Ανοιχτό πράσινο",
        "#9370DB": "Μεσαίο Μωβ",
        "#9400D3": "Σκούρο βιολετί",
        "#98FB98": "Απαλό πράσινο",
        "#9932CC": "Έντονο βιολετί",
        "#9ACD32": "Κίτρινο πράσινο",
        "#A020F0": "Μπλέ μαντζέντα",
        "#A0522D": "Sienna",
        "#A52A2A": "Καφέ",
        "#A9A9A9": "Σκούρο γκρι",
        "#ADD8E6": "Γαλάζιο",
        "#ADFF2F": "Πράσινο κίτρινο",
        "#AFEEEE": "Απαλό τυρκουάζ",
        "#B03060": "Μπορντό",
        "#B0C4DE": "Light Steel Blue",
        "#B0E0E6": "Κυανό παστέλ",
        "#B22222": "Βαθύ κόκκινο",
        "#B8860B": "Σκούρο χρυσό",
        "#BA55D3": "Μεσαίο βιολετί",
        "#BC8F8F": "Ρόζ Μπράουν",
        "#BDB76B": "Σκούρο Χακί",
        "#BEBEBE": "Γκρί",
        "#C0C0C0": "Ασημί",
        "#C71585": "Έντονο ροζ",
        "#CD5C5C": "Μεσαίο κόκκινο",
        "#CD853F": "Μεσαίο πορτοκαλί",
        "#D2691E": "Βαθύ πορτοκαλί",
        "#D2B48C": "Ταμπά",
        "#D3D3D3": "Ανοιχτό γκρι",
        "#D8BFD8": "Ανοιχτό μωβ",
        "#DA70D6": "Απαλή μανζέντα",
        "#DAA520": "Χρυσό",
        "#DB7093": "Απαλό ροζ",
        "#DC143C": "Βυσσινί",
        "#DCDCDC": "Πολύ ανοιχτό γκρι",
        "#DDA0DD": "Δαμασκηνί",
        "#DEB887": "Ανοιχτό καφέ",
        "#E0FFFF": "Ελαφρύ κυανό",
        "#E6E6FA": "Λεβάντα",
        "#E9967A": "Σκούρο σομόν",
        "#EE82EE": "Βιολετί",
        "#EEE8AA": "Απαλό χρυσό",
        "#F08080": "Ανοιχτό κοραλί",
        "#F0E68C": "Χακί",
        "#F0F8FF": "Απαλό γαλάζιο",
        "#F0FFF0": "Μελί",
        "#F0FFFF": "Απαλό κυανό",
        "#F4A460": "Καφέ της άμμου",
        "#F5DEB3": "Απαλό μπεζ",
        "#F5F5DC": "Μπεζ",
        "#F5F5F5": "Πολύ απαλό γκρί",
        "#F5FFFA": "Απαλή μέντα",
        "#F8F8FF": "Πολύ απαλό μπλε",
        "#FA8072": "Σομόν",
        "#FAEBD7": "Λευκή αντίκα",
        "#FAF0E6": "Αχνό πορτοκαλί",
        "#FAFAD2": "Ανοιχτό κίτρινο",
        "#FDF5E6": "Πολύ αχνό πορτοκαλί",
        "#FF0000": "Κόκκινο",
        "#FF00FF": "Φουξία",
        "#FF1493": "Βαθύ ροζ",
        "#FF4500": "Πορτοκαλοκόκκινο",
        "#FF6347": "Ελαφρύ κόκκινο",
        "#FF69B4": "Φωτεινό ροζ",
        "#FF7F50": "Κοραλί",
        "#FF8C00": "Σκούρο πορτοκαλί",
        "#FFA07A": "Ανοιχτό σομόν",
        "#FFA500": "Πορτοκαλί",
        "#FFB6C1": "Ανοιχτό ροζ",
        "#FFC0CB": "Ροζ",
        "#FFD700": "Σκούρο κίτρινο",
        "#FFDAB9": "Peach Puff",
        "#FFDEAD": "Ανοιχτό καφέ",
        "#FFE4B5": "Πολύ ανοιχτό καφέ",
        "#FFE4C4": "Απαλό μανταρινί",
        "#FFE4E1": "Πολύ αχνό κόκκινο",
        "#FFEBCD": "Λευκό του αμυγδάλου",
        "#FFEFD5": "Απαλό πορτοκαλί",
        "#FFF0F5": "Απαλή λεβάντα",
        "#FFF5EE": "Πολύ αχνό πορτοκαλί",
        "#FFF8DC": "Ανοιχτό κίτρινο",
        "#FFFACD": "Λεμονί",
        "#FFFAF0": "Κρεμ απαλό",
        "#FFFAFA": "Πολύ αχνό ροζ",
        "#FFFF00": "Κίτρινο",
        "#FFFFE0": "Ανοιχτό κίτρινο",
        "#FFFFF0": "Ιβουάρ",
        "#FFFFFF": "Λευκό"
      },
      "select": "Επιλέξτε χρώματα"
    },
    "COUNTRY": {
      "name": "Χώρα",
      "options": {
        "Albania": "Αλβανία",
        "Austria": "Αυστρία",
        "Belarus": "Λευκορωσία",
        "Belgium": "Βέλγιο",
        "Bosnia and Herzegovina": "Βοσνία-Ερζεγοβίνη",
        "Bulgaria": "Βουλγαρία",
        "Croatia": "Κροατία",
        "Cyprus": "Κύπρος",
        "Czech Republic": "Τσεχική Δημοκρατία",
        "Denmark": "Δανία",
        "Estonia": "Εσθονία",
        "Europe": "Ευρώπη",
        "Finland": "Φινλανδία",
        "France": "Γαλλία",
        "Georgia": "Γεωργία",
        "Germany": "Γερμανία",
        "Greece": "Ελλάδα",
        "Holy See (Vatican City State)": "Αγία Έδρα (Κράτος της Πόλης του Βατικανού)",
        "Hungary": "Ουγγαρία",
        "Iceland": "Ισλανδία",
        "Ireland": "Ιρλανδία",
        "Israel": "Ισραήλ",
        "Italy": "Ιταλία",
        "Latvia": "Λετονία",
        "Lithuania": "Λιθουανία",
        "Luxembourg": "Λουξεμβούργο",
        "Macedonia": "Μακεδόνια",
        "Malta": "Μάλτα",
        "Moldova": "Μολδαβία",
        "Montenegro": "Μαυροβούνιο",
        "Netherlands": "Ολλανδία",
        "Norway": "Νορβηγία",
        "Poland": "Πολωνία",
        "Portugal": "Πορτογαλία",
        "Romania": "Ρουμανία",
        "Russia": "Ρωσία",
        "Serbia": "Σερβία",
        "Slovakia": "Σλοβακία",
        "Slovenia": "Σλοβενία",
        "Spain": "Ισπανία",
        "Sweden": "Σουηδία",
        "Switzerland": "Ελβετία",
        "Turkey": "Τουρκία",
        "Ukraine": "Ουκρανία",
        "United Kingdom": "Ηνωμένο Βασίλειο",
        "United States of America": "Ηνωμένες Πολιτείες της Αμερικής"
      },
      "select": "Επιλέξτε χώρες παροχής"
    },
    "CREATOR": {
      "moreName": "δημιουργοί",
      "name": "Δημιουργός | Δημιουργοί",
      "select": "Επιλέξτε δημιουργούς"
    },
    "DATA_PROVIDER": {
      "moreName": "Ιδρύματα",
      "name": "Ίδρυμα | Ιδρύματα",
      "select": "Επιλέξτε Ιδρύματα"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Προσανατολισμός εικόνας | Προσανατολισμοί εικόνας",
      "options": {
        "landscape": "Οριζόντιος",
        "portrait": "Κάθετος"
      },
      "select": "Επιλέξτε προσανατολισμούς εικόνας"
    },
    "IMAGE_SIZE": {
      "name": "Μέγεθος εικόνας | Μεγέθη εικόνων",
      "options": {
        "extra_large": "Πολύ μεγάλο 4 MP+ (π.χ. 2688 x 1520 px)",
        "large": "Μεγάλο 1-4 MP (π.χ. 1920 x 1080 px)",
        "medium": "Μεσαίο 0,5-1 MP (π.χ. 850 x 850 px)",
        "small": "Μικρό < 0,5 MP (π.χ. 650 x 600 px)"
      },
      "select": "Επιλέξτε μεγέθη εικόνας"
    },
    "LANGUAGE": {
      "name": "Γλώσσα | Γλώσσες",
      "options": {
        "ar": "Αραβικά",
        "bg": "Βουλγαρική",
        "bs": "Βοσνιακή",
        "ca": "Καταλανικά",
        "cs": "Τσεχική",
        "cy": "Ουαλικά",
        "da": "Δανικά",
        "de": "Γερμανικά",
        "el": "Ελληνική",
        "en": "Αγγλικά",
        "es": "Ισπανικά",
        "et": "Εσθονικά",
        "fi": "Φινλανδική",
        "fr": "Γαλλικά",
        "ga": "Ιρλανδική",
        "gd": "Κελτικά",
        "he": "Εβραϊκά",
        "hr": "Κροατικά",
        "hu": "Ουγγρικό",
        "is": "Ισλανδική",
        "it": "Ιταλικά",
        "lt": "Λιθουανικά",
        "lv": "Λετονία",
        "mk": "Μακεδονικό",
        "mt": "Μαλτέζικα",
        "mul": "Πολλαπλές γλώσσες",
        "nl": "Ολλανδικά",
        "no": "Νορβηγικό",
        "pl": "Πολωνικά",
        "pt": "Πορτογαλικά",
        "ro": "Ρουμανικά",
        "ru": "Ρωσική",
        "sk": "Σλοβακική",
        "sl": "Σλοβενική",
        "sq": "Αλβανικά",
        "sr": "Σέρβικα",
        "sv": "Σουηδικά",
        "tr": "Τουρκικά",
        "uk": "Ουκρανικό"
      },
      "select": "Επιλέξτε γλώσσες"
    },
    "MIME_TYPE": {
      "name": "Μορφή αρχείου | Μορφές αρχείων",
      "options": {
        "text/plain": "Απλό κείμενο"
      },
      "select": "Επιλέξτε μορφές αρχείων"
    },
    "PROVIDER": {
      "moreName": "Φορείς",
      "name": "Φορέας | Φορείς",
      "select": "Επιλέξτε Φορείς"
    },
    "REUSABILITY": {
      "name": "Μπορώ να το χρησιμοποιήσω αυτό;",
      "options": {
        "open": "Ναι",
        "permission": "Ίσως, ζητήστε άδεια",
        "restricted": "Ναι, υπό όρους",
        "uncategorized": "Χωρίς κατηγορία"
      },
      "select": "Επιλέξτε αν μπορείτε να το χρησιμοποιήσετε"
    },
    "TYPE": {
      "name": "Τύπος μέσων",
      "options": {
        "3D": "3D",
        "IMAGE": "Εικόνα",
        "SOUND": "Ήχος",
        "TEXT": "Κείμενο",
        "VIDEO": "Βίντεο"
      },
      "select": "Επιλέξτε τύπους μέσων"
    },
    "api": {
      "name": "Αναζήτηση για",
      "options": {
        "fulltext": "Αντικείμενα με πλήρες κείμενο",
        "metadata": "Αντικείμενα μόνο με μεταδεδομένα"
      },
      "switch": "Αναζήτηση μόνο στο περιεχόμενο των στοιχείων με πλήρες κείμενο",
      "switchMoreInfo": "Σε αυτή τη συλλογή, μπορείτε να επιλέξετε τι θέλετε να αναζητήσετε: αν αυτός ο διακόπτης είναι ενεργοποιημένος, τότε θα κάνετε αναζήτηση στο κείμενο της εφημερίδας και του εγγράφου- αν είναι απενεργοποιημένος, τότε θα κάνετε αναζήτηση στις πληροφορίες που περιγράφουν το αντικείμενο, όπως ακριβώς κάνετε πάντα στις περισσότερες συλλογές."
    },
    "button": {
      "apply": "Εφαρμογή",
      "cancel": "Ακύρωση",
      "morefilters": "Περισσότερα φίλτρα",
      "reset": "Επαναφορά",
      "showAll": "Εμφάνιση όλων {label}",
      "showLess": "Εμφάνιση λιγότερων {label}"
    },
    "collection": {
      "name": "Θέμα",
      "options": {
        "archaeology": "Αρχαιολογία",
        "art": "Τέχνη",
        "fashion": "Μόδα",
        "industrial": "Βιομηχανική κληρονομιά",
        "manuscript": "Χειρόγραφα",
        "map": "Χάρτες και γεωγραφία",
        "migration": "Μετανάστευση",
        "music": "Μουσική",
        "nature": "Φυσική ιστορία",
        "newspaper": "Εφημερίδες",
        "photography": "Φωτογραφία",
        "sport": "Άθλημα",
        "ww1": "Πρώτος Παγκόσμιος Πόλεμος"
      },
      "select": "Επιλέξτε ένα θέμα"
    },
    "contentTier": {
      "name": "Ποιότητα αντικειμένου",
      "options": {
        "*": "Περιλαμβάνει αντικείμενα που δεν πληρούν τα κριτήρια δημοσίευσής μας",
        "0": "Εμφανίστε μόνο αντικείμενα που δεν πληρούν τα κριτήρια δημοσίευσης",
        "1": "Χαμηλή ποιότητα",
        "2": "Μέτρια ποιότητα",
        "3": "Υψηλής ποιότητας & επαναχρησιμοποιήσιμο με όρους",
        "4": "Υψηλής ποιότητας & ελεύθερα επαναχρησιμοποιήσιμο"
      },
      "select": "Επιλέξτε ιδιότητες αντικειμένου"
    },
    "moreOptions": "Αναζητήστε για να βρείτε {0} περισσότερα {1}.",
    "proxy_dc_format": {
      "name": "Μορφή | Μορφές",
      "select": "Επιλέξτε μορφές"
    },
    "proxy_dc_type": {
      "name": "Τύπος | Τύποι",
      "select": "Επιλέξτε τύπους"
    },
    "proxy_dcterms_issued": {
      "name": "Ημερομηνία έκδοσης"
    },
    "proxy_dcterms_medium": {
      "name": "Μέσο | Μέσα",
      "select": "Επιλέξτε μέσο διάθεσης"
    }
  },
  "feedback": {
    "emailOptional": "Μπορεί να θέλουμε να επικοινωνήσουμε. Εισάγετε το email σας εάν δέχεστε να επικοινωνήσουμε μαζί σας.",
    "failed": "Το αίτημα απέτυχε. Προσπαθήστε ξανά.",
    "form": {
      "placeholders": {
        "email": "εισάγετε την ηλεκτρονική σας διεύθυνση",
        "feedback": "Εισάγετε τα σχόλιά σας εδώ"
      }
    },
    "policies": "Συνεχίζοντας, συμφωνείτε με το {0} και αποδέχεστε το {1} .",
    "privacyPolicy": "Πολιτική απορρήτου",
    "success": "Τα σχόλιά σας έχουν σταλεί.",
    "termsOfService": "Όροι χρήσης",
    "thankYou": "Σας ευχαριστώ!",
    "title": "Στείλετε τα σχόλιά σας",
    "validEmail": "Εισάγετε μια έγκυρη διεύθυνση email",
    "validFeedback": "Τα σχόλιά σας πρέπει να αποτελούνται από τουλάχιστον 5 λέξεις"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Συντελεστές",
      "dcCoverage": "Μέρος-Ώρα",
      "dcCreator": "Δημιουργός",
      "dcDate": "Ημερομηνία",
      "dcDescription": "Περιγραφή",
      "dcDuration": "Διάρκεια",
      "dcFormat": "Μορφή",
      "dcIdentifier": "Αναγνωριστικό",
      "dcLanguage": "Γλώσσα",
      "dcPublisher": "Εκδότης",
      "dcRelation": "Σχέσεις",
      "dcRights": "Δικαιώματα",
      "dcSource": "Πηγή",
      "dcSubject": "Θέμα",
      "dcTitle": "Τίτλος",
      "dcType": "Τύπος αντικειμένου",
      "dctermsCreated": "Ημερομηνία δημιουργίας",
      "dctermsExtent": "Έκταση",
      "dctermsHasPart": "Αποτελείται από",
      "dctermsHasVersion": "Έχει έκδοση",
      "dctermsIsFormatOf": "Είναι μορφή του",
      "dctermsIsPartOf": "Είναι μέρος του",
      "dctermsIsReferencedBy": "Αναφέρεται από",
      "dctermsIsReplacedBy": "Αντικαθίσταται από",
      "dctermsIsRequiredBy": "Απαιτείται από",
      "dctermsIssued": "Ημερομηνία έκδοσης",
      "dctermsMedium": "Μέσο",
      "dctermsProvenance": "Προέλευση",
      "dctermsReferences": "Αναφορές",
      "dctermsSpatial": "Μέρη",
      "dctermsTOC": "Πίνακας περιεχομένων",
      "dctermsTemporal": "Χρονική περίοδος",
      "edmCountry": "Χώρα",
      "edmCurrentLocation": "Τρέχουσα τοποθεσία",
      "edmDataProvider": "Πάροχος",
      "edmHasMet": "Έχει συναντήσει",
      "edmIncorporates": "Ενσωματώνει",
      "edmIntermediateProvider": "Ενδιάμεσος πάροχος",
      "edmIsDerivativeOf": "Είναι παράγωγο του",
      "edmIsRelatedTo": "Σχετίζεται με",
      "edmIsRepresentationOf": "Είναι αναπαράσταση του",
      "edmIsSimilarTo": "Είναι παρόμοιο με",
      "edmIsSuccessorOf": "Είναι διάδοχος του",
      "edmProvider": "Πάροχος",
      "edmRealizes": "Πραγματοποιεί",
      "edmRights": "Άδεια χρήσης αυτού του αρχείου (εκτός αν ορίζεται διαφορετικά)",
      "edmUgc": "Περιεχόμενο δημιουργημένο από το χρήστη",
      "europeanaCollectionName": "Όνομα συλλογής",
      "keywords": "Λέξεις-κλειδιά (παρέχονται από την κοινότητα)",
      "timestampCreated": "Δημιουργία χρονικής σήμανσης",
      "timestampUpdate": "Ενημέρωση χρονικής σήμανσης",
      "wasPresentAt": "Ήταν παρών/ούσα στο",
      "year": "Έτος"
    },
    "webResource": {
      "about": "RDF σχετικά με",
      "dcDescription": "Περιγραφή",
      "ebucoreHasMimeType": "Τύπος Ebucore MIME",
      "edmRights": "Άδεια χρήσης για αυτό το πολυμέσο",
      "rdfAbout": "RDF Σχετικά με"
    }
  },
  "filter": "Φίλτρο",
  "filterResults": "Αποτελέσματα φίλτρου",
  "footer": {
    "customiseWebsiteLanguage": "Προσαρμογή γλώσσας ιστότοπου",
    "disclaimerLine1": "Η Europeana είναι μια πρωτοβουλία της Ευρωπαϊκής Ένωσης, που χρηματοδοτείται από τη Διευκόλυνση «Συνδέοντας την Ευρώπη» και τα κράτη μέλη της Ευρωπαϊκής Ένωσης. Οι υπηρεσίες Europeana, συμπεριλαμβανομένου αυτού του ιστότοπου, λειτουργούν από μια κοινοπραξία υπό την ηγεσία του Ιδρύματος Europeana βάσει σύμβασης παροχής υπηρεσιών με την Ευρωπαϊκή Επιτροπή.",
    "disclaimerLine2": "Η Ευρωπαϊκή Επιτροπή δεν εγγυάται την ακρίβεια των πληροφοριών και δεν αποδέχεται καμία υπαιτιότητα ή ευθύνη όσον αφορά τις πληροφορίες σε αυτόν τον ιστότοπο. Ούτε η Ευρωπαϊκή Επιτροπή, ούτε οποιοδήποτε πρόσωπο που ενεργεί για λογαριασμό της Ευρωπαϊκής Επιτροπής, είναι υπαίτιο ή υπεύθυνο για την ακρίβεια ή τη χρήση των πληροφοριών σε αυτόν τον ιστότοπο.",
    "findUsElsewhere": "Βρείτε μας αλλού",
    "imageDescription": "Χρηματοδοτείται από την Ευρωπαϊκή Ένωση",
    "navigation": {
      "MoreInfoLabel": "Περισσότερες πληροφορίες",
      "about": "Σχετικά με εμάς",
      "accessibility": "Προσβασιμότητα",
      "cookies": "Cookies",
      "forDevelopers": "Για προγραμματιστές",
      "help": "Βοήθεια",
      "privacy": "Πολιτική απορρήτου",
      "provide": "Γίνετε πάροχος δεδομένων",
      "subscribe": "Εγγραφείτε στο ενημερωτικό μας δελτίο",
      "terms": "Όροι χρήσης"
    },
    "ourMission": "Η αποστολή μας",
    "ourMissionQuote": "Η Europeana συνδράμει στην ψηφιοποίηση του τομέα της πολιτιστικής κληρονομιάς. Αναπτύσσουμε τεχνογνωσία, εργαλεία και πολιτικές για τον ενστερνισμό της ψηφιακής αλλαγής και την ενθάρρυνση συνεργασιών που προωθούν την καινοτομία."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ","
  },
  "galleries": {
    "description": "Εξερευνήστε τις συλλογές μας",
    "galleries": "Γκαλερί"
  },
  "goToRecord": "Μετάβαση στο αντικείμενο",
  "header": {
    "backToMenu": "Κλείσιμο πλαισίου αναζήτησης",
    "clearQuery": "Διαγραφή ιστορικού αναζήτησης",
    "closeSidebar": "Κλείσιμο μενού",
    "entireCollection": "Αναζητήστε τον όρο {query} σε όλη τη συλλογή",
    "europeanaHome": "Αρχική σελίδα της Europeana",
    "inCollection": "Αναζητήστε τον όρο {query} στη συλλογή {collection}",
    "navigation": {
      "about": "Σχετικά με εμάς",
      "collections": "Συλλογές",
      "europeanaClassroom": "Για δασκάλους",
      "help": "Βοήθεια",
      "home": "Aρχική σελίδα",
      "pro": "Για επαγγελματίες",
      "stories": "Ιστορίες"
    },
    "quickSearch": "Γρήγορη αναζήτηση",
    "searchFor": "Αναζήτηση του όρου {query}",
    "searchForEverything": "Αναζητήστε τα πάντα",
    "searchForEverythingInCollection": "Αναζητήστε τα πάντα στη συλλογή {collection}",
    "searchForEverythingInEntireCollection": "Αναζητήστε τα πάντα σε ολόκληρη τη συλλογή μας",
    "searchForm": "Φόρμα αναζήτησης",
    "showSidebar": "Εμφάνιση μενού",
    "sideNavigation": "Πλευρική πλοήγηση"
  },
  "homeLinkAlt": "Αρχική σελίδα της Europeana",
  "homePage": {
    "discoverEditorial": "Τελευταίες ιστορίες",
    "storiesCTA": "Δείτε όλες τις ιστορίες",
    "subHeadline": "Αναζητήστε, αποθηκεύστε και μοιραστείτε τέχνη, βιβλία, ταινίες και μουσική από χιλιάδες πολιτισμικούς θεσμούς",
    "themesCTA": "Δείτε όλα τα θέματα",
    "themesTitle": "Εξερευνήστε ανά θέμα",
    "title": "Ανακαλύψτε την {digital} πολιτιστική κληρονομιά της Ευρώπης",
    "titleDigital": "ψηφιακή"
  },
  "imageSlider": {
    "handle": "Ρυθμιστικό"
  },
  "items": {
    "itemCount": "1 αντικείμενο |{count} αντικείμενα",
    "itemOf": "{max} από {count} αντικείμενα",
    "recent": "Πρόσφατα αντικείμενα",
    "recommended": "Προτεινόμενα αντικέιμενα",
    "youMightLike": "Αντικείμενα που μπορεί να σας αρέσουν"
  },
  "klaro": {
    "main": {
      "acceptAll": "Αποδοχή όλων",
      "acceptSelected": "Αποδοχή επιλεγμένων",
      "consentModal": {
        "description": "Λαμβάνουμε σοβαρά υπόψη το απόρρητο των δεδομένων σας. Εδώ μπορείτε να αξιολογήσετε και να προσαρμόσετε τις υπηρεσίες που θα θέλαμε να χρησιμοποιήσουμε σε αυτόν τον ιστότοπο. Έχετε τον έλεγχο! Ενεργοποιήστε ή απενεργοποιήστε τις υπηρεσίες κατά την κρίση σας.",
        "title": "Υπηρεσίες που θα θέλαμε να χρησιμοποιήσουμε."
      },
      "consentNotice": {
        "description": "Νοιαζόμαστε για το απόρρητό σας και χρησιμοποιούμε μόνο δεδομένα για τη βελτίωση της εμπειρίας σας. Δεν χρησιμοποιούμε προσωπικές πληροφορίες για διαφήμιση. Μπορείτε να αλλάζετε τη συγκατάθεσή σας κάθε 15 ημέρες.",
        "learnMore": "Άσε με να διαλέξω"
      },
      "decline": "ΑΡΝΟΥΜΑΙ",
      "ok": "ΕΝΤΑΞΕΙ",
      "purposes": {
        "essential": {
          "description": "Αυτές οι υπηρεσίες είναι απαραίτητες για τη σωστή λειτουργία αυτού του ιστότοπου. Περιλαμβάνουν την προβολή αποτελεσμάτων αναζήτησης και τις προτιμήσεις γλώσσας, διατηρούν την κατάσταση σύνδεσης και διατηρούν την επίσκεψή σας ασφαλή. Δεν μπορείτε να τα απενεργοποιήσετε καθώς ο ιστότοπος δεν θα λειτουργούσε σωστά διαφορετικά.",
          "title": "Βασικές υπηρεσίες για ασφάλεια και προσαρμογή"
        },
        "usage": {
          "description": "Αυτές οι υπηρεσίες συλλέγουν τις πληροφορίες για να μας βοηθήσουν να κατανοήσουμε καλύτερα πώς χρησιμοποιείται ο ιστότοπος και πού βρίσκονται τα σημεία που προκαλούν προβλήματα, δίνοντάς μας τη δυνατότητα να κάνουμε τεκμηριωμένες επιλογές για να βελτιώσουμε την εμπειρία σας.",
          "title": "Υπηρεσίες για την καταγραφή της χρήσης του ιστότοπου και της ανατροφοδότησης"
        }
      },
      "service": {
        "disableAll": {
          "description": "Χρησιμοποιήστε αυτόν τον διακόπτη για να ενεργοποιήσετε ή να απενεργοποιήσετε όλες τις προαιρετικές υπηρεσίες.",
          "title": "Ενεργοποιήστε ή απενεργοποιήστε όλες τις υπηρεσίες"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Βοηθά στη βελτίωση της ιστοσελίδας μας εφαρμόζοντας περιστασιακά πειραματικές αλλαγές.",
        "title": "Δοκιμή Α/Β"
      },
      "auth-strategy": {
        "description": "Θυμάται τη στρατηγική εξουσιοδότησης που πρέπει να χρησιμοποιήσετε για να συνδεθείτε.",
        "title": "Στρατηγική Auth"
      },
      "debugSettings": {
        "description": "Βοηθά στην αποσφαλμάτωση αιτημάτων API",
        "title": "Εναλλαγή εντοπισμού σφαλμάτων"
      },
      "hotjar": {
        "description": "Ενεργοποιεί ένα widget έρευνας, δίνοντάς σας τη δυνατότητα να απαντήσετε στις έρευνες ικανοποίησης των επισκεπτών μας.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Θυμάται τη γλώσσα διασύνδεσης που προτιμάτε για μελλοντική πρόσβαση.",
        "title": "Κωδικός γλώσσας"
      },
      "jira-servicedesk": {
        "description": "Ενεργοποιεί ένα widget έρευνας, δίνοντάς σας τη δυνατότητα να απαντήσετε στις έρευνες ικανοποίησης των επισκεπτών μας.",
        "title": "Γραφείο εξυπηρέτησης Jira"
      },
      "matomo": {
        "description": "Συλλέγει ανώνυμα στατιστικά στοιχεία σχετικά με τον τρόπο αλληλεπίδρασης των επισκεπτών με τον ιστότοπο.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Εμφανίζει μια ειδοποίηση όταν γίνονται διαθέσιμες νέες λειτουργίες.",
        "title": "Ειδοποίηση νέας λειτουργίας"
      },
      "searchResultsView": {
        "description": "Θυμάται αν προτιμάτε να βλέπετε τα αποτελέσματα αναζήτησης σε προβολή λίστας ή πλέγματος.",
        "title": "Προβολή αποτελεσμάτων αναζήτησης (λίστα / πλέγμα)"
      }
    }
  },
  "layout": {
    "skipToMain": "Μετάβαση στο περιεχόμενο της σελίδας"
  },
  "learnMore": "Μάθετε για την πηγή αυτής της περιγραφής",
  "loading": "Φόρτωση",
  "loadingResults": "Φόρτωση αποτελεσμάτων",
  "messages": {
    "copyToClipboardSuccess": "Αντιγράφηκε στο πρόχειρο",
    "externalContentError": "Η φόρτωση του εξωτερικού συνδέσμου απέτυχε",
    "notFound": "Δεν βρέθηκε",
    "paginationLimitExceeded": "Μπορείτε να δείτε μόνο τα πρώτα {limit} αποτελέσματα αναζήτησης."
  },
  "modal": {
    "download": {
      "clickToCopy": "Κάντε κλικ στην αναφορά για να την αντιγράψετε",
      "modalIntro": "Αν χρησιμοποιήσετε αυτό το στοιχείο στο διαδίκτυο ή αλλού, μην ξεχάσετε να εμφανίσετε την ακόλουθη αναφορά δίπλα του:",
      "modalTitle": "Πες ευχαριστώ"
    }
  },
  "multilingual": {
    "automated": "Αυτοματοποιημένη μετάφραση",
    "enrichment": "Εμπλουτισμός με έργα συνεργατών",
    "other": "Άλλες γλώσσες",
    "stopTranslating": "Διακοπή μετάφρασης αυτού του στοιχείου σε {0}.",
    "translateLanguage": "Θα θέλατε να δείτε αυτό το στοιχείο στα {0};",
    "translateQuotaError": "Η υπηρεσία μετάφρασης δεν είναι προσωρινά διαθέσιμη. Παρακαλώ προσπαθήστε ξανά αργότερα."
  },
  "newFeatureNotification": {
    "dismiss": "Κλείσιμο",
    "readMore": "Διαβάστε περισσότερα",
    "text": {
      "searchFilters": "Τώρα μπορείτε να αναζητήσετε τιμές στα μεμονωμένα φίλτρα. Τσέκαρέ το!"
    }
  },
  "newWindow": "ανοίγει σε νέο παράθυρο",
  "noMoreResults": "Δεν υπάρχουν άλλα αποτελέσματα για την αναζήτησή σας",
  "noResults": "Δεν βρέθηκαν αποτελέσματα",
  "of": "Του",
  "organisation": {
    "city": "Πόλη",
    "country": "Χώρα",
    "englishName": "Αγγλικό όνομα",
    "nameAcronym": "Ακρωνύμιο ονόματος"
  },
  "pageHasLoaded": "έχει φορτωθεί",
  "pageNumber": "Αριθμός σελίδας",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Ονομα"
        },
        "title": "Οργανώσεις"
      },
      "persons": {
        "title": "Άτομα"
      },
      "places": {
        "title": "Μέρη"
      },
      "table": {
        "items": "Στοιχεία",
        "name": "Ονομα"
      },
      "times": {
        "title": "Φορές"
      },
      "topics": {
        "title": "Θέματα"
      }
    }
  },
  "pagination": {
    "label": "Σελιδοποίηση"
  },
  "readMore": "Διαβάστε περισσότερα",
  "recommendation": {
    "prompts": {
      "accept": "Αντίχειρας προς τα επάνω για να προσθέσετε στη συλλογή",
      "reject": "Αντίχειρας κάτω αν το αντιπαθείς"
    }
  },
  "record": {
    "IIIFViewer": "Πρόγραμμα προβολής IIIF",
    "actions": {
      "pin": "Καρφιτσώστε το αντικείμενο σε διαθέσιμες Οντότητες"
    },
    "allMetaData": "Όλα τα μεταδεδομένα",
    "copyEmbedLabel": "Ενσωμάτωση κώδικα (κάντε κλικ για αντιγραφή)",
    "exploreMore": "Εξερευνήστε περισσότερα",
    "extendedInformation": "Εκτεταμένες πληροφορίες",
    "goodToKnow": "Χρήσιμες πληροφορίες",
    "hideAll": "Απόκρυψη όλων των πληροφοριών",
    "location": "Τοποθεσία",
    "locationOnMap": "Τοποθεσία στο χάρτη",
    "mediaPlayer": "Πρόγραμμα αναπαραγωγής πολυμέσων",
    "record": "Aντικείμενο",
    "showAll": "Εμφάνιση όλων των πληροφοριών",
    "similarItems": "Παρόμοια αντικείμενα",
    "status": {
      "unpublished": "[Μη δημοσιευμένο στοιχείο]"
    },
    "transcription": "Απομαγνητοφώνηση",
    "transcriptionDisclaimer": "Το περιεχόμενο προέρχεται από το κοινό και όχι από το ίδρυμα που παρείχε το αντικείμενο."
  },
  "related": {
    "editorial": {
      "title": "Ιστορίες που μπορεί να σας αρέσουν"
    }
  },
  "relatedCollections": "Σχετικές συλλογές",
  "removeFilter": "Κατάργηση φίλτρου {filterLabel}",
  "reset": "Επαναφορά",
  "resourceWikimedia": "Πηγή από τα Wikimedia Commons",
  "results": "Αποτελέσματα",
  "resultsFor": "Αποτελέσματα για {0}",
  "resultsLimitWarning": "Δεν εμφανίζονται επιπλέον αποτελέσματα, καθώς εμφανίζονται μόνο τα πρώτα 1.000 πιο σχετικά αποτελέσματα. Εάν δεν βρείτε αυτό που ψάχνετε, προσπαθήστε να αλλάξετε τα φίλτρα αναζήτησής σας.",
  "resultsWithin": "Αποτελέσματα εντός {0} {1} για {2}",
  "search": {
    "boost": {
      "placeholder": "Εισάγετε ερώτημα ενίσχυσης πεδίου"
    },
    "title": "Αναζήτηση"
  },
  "searchHasLoaded": "{0} αποτελέσματα που επιστράφηκαν",
  "searchPlaceholder": "Αναζήτηση 50+ εκατομμυρίων αντικειμένων",
  "searchResults": "Αναζήτηση",
  "searchResultsFor": "{0} - Αναζήτηση",
  "searchSuggestions": "Αναζήτηση προτάσεων",
  "searchTier": {
    "button": {
      "hide": "Απόκρυψη αυτών των στοιχείων",
      "show": "Εμφάνιση αυτών των στοιχείων"
    },
    "text": {
      "hide": "Εμφανίζονται στοιχεία που δεν πληρούν τα κριτήρια δημοσίευσης.",
      "show": "Περισσότερα στοιχεία αντιστοιχούν στην αναζήτησή σας, αλλά δεν πληρούν τα κριτήρια δημοσίευσης."
    }
  },
  "searchViews": {
    "grid": "Προβολή πλέγματος",
    "list": "Προβολή λίστας",
    "mosaic": "Προβολή μωσαϊκού"
  },
  "set": {
    "actions": {
      "addTo": "Προσθήκη στη συλλογή",
      "create": "Δημιουργία συλλογής",
      "createNew": "Δημιουργία νέας συλλογής",
      "delete": "Διαγραφή συλλογής",
      "edit": "Επεξεργασία συλλογής",
      "update": "Ενημέρωση συλλογής"
    },
    "form": {
      "description": "Περιγραφή συλλογής",
      "private": "Να παραμείνει ιδιωτική η συλλογή",
      "required": "Υποχρεωτικά πεδία",
      "title": "Όνομα συλλογής"
    },
    "labels": {
      "curatedBy": "Επιμέλεια:",
      "private": "Ιδιωτική συλλογή"
    },
    "notifications": {
      "deleted": "Η συλλογή σας διαγράφηκε.",
      "likeLimit": {
        "body": "Δυστυχώς, προς το παρόν μπορείτε να κάνετε like σε έως 100 αντικείμενα. Το όριο αυτό θα καταργηθεί σύντομα!",
        "title": "100 like"
      },
      "updated": "Το αντικείμενο προστέθηκε στη συλλογή."
    },
    "prompts": {
      "delete": "Είστε σίγουρος/η ότι θέλετε να διαγράψετε αυτήν τη συλλογή; Εάν τη διαγράψετε, θα χάσετε όλα τα αντικείμενα που έχετε προσθέσει."
    }
  },
  "showLess": "Εμφάνιση λιγότερων",
  "showMore": "Εμφάνιση περισσότερων",
  "sideFilters": {
    "noOptions": "Δεν υπάρχουν διαθέσιμες επιλογές",
    "search": "Αναζήτηση"
  },
  "statuses": {
    "liked": "Άρεσε",
    "pinned": "Καρφιτσωμένο"
  },
  "storiesPage": {
    "title": "Ιστορίες"
  },
  "website": "Δικτυακός τόπος",
  "youMightAlsoLike": "Μπορεί επίσης να σας αρέσει"
};
